import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

//
import Account from "../../assets/img/user-images/account.png";

//
import ImageBox from "../../components/general/ImageBox";

function AdminLogin() {
  const navigate = useNavigate();
  const { token } = useParams();

  useEffect(() => {
    localStorage.setItem("token", token);
    navigate("/app");
  }, []);

  return (
    <div>
      <ImageBox src={Account} />
      <h4>Admin Login</h4>
    </div>
  );
}

export default AdminLogin;
